<form [formGroup]="form" ngxsForm="productDetails.licenseForm">
    <nz-form-item class="margin-right-30">
        <leap-form-guidance>Choose License:</leap-form-guidance>
        <nz-form-control>
            <nz-select formControlName="licenseTypeValue" [nzCustomTemplate]="licenseTemplate">
                <nz-option *ngFor="let item of licenseTypes" [nzValue]="item"
                           [nzLabel]="item?.slice(0, -8)"></nz-option>
            </nz-select>
        </nz-form-control>
    </nz-form-item>

    <nz-form-item *ngIf="durationTypes?.length">
        <leap-form-guidance>{{ form.get('combinedDuration').value?.duration !== null ? 'Term Duration:' : 'Frequency:' }}</leap-form-guidance>
        <nz-form-control>
            <nz-select formControlName="combinedDuration">
                <nz-option *ngFor="let item of durationTypes" [nzValue]="item"
                           [nzLabel]="(item?.duration ? item?.duration + ' ': '') + item?.durationType"></nz-option>
            </nz-select>
        </nz-form-control>
    </nz-form-item>
</form>

<ng-template #licenseTemplate let-item>
    <b>{{ item.nzValue.slice(0, -8) }}</b>
</ng-template>
